import * as React from 'react';
import { gamification } from '../../api/event';
import { EVENTS, STORAGE_KEYS } from '../../Utils/constants';
import { clearStorage, setItem } from '../../Utils/Storage';
import { redirectTo } from '../../Utils/utils';
import './index.css';

const LogoutButton = () => {
  return (
    <div>
      <button onClick={ContainerLogout} className='logout_button'>
        Logout
      </button>
    </div>
  );
};

export const ContainerLogout = () => {
  gamification({
    type: EVENTS.LOGOUT,
    name: EVENTS.LOGOUT
  });

  clearStorage();
  setItem(
    STORAGE_KEYS.CUSTOM_DOMAIN,
   process.env.CUSTOM_DOMAIN
  );
  redirectTo('/login');
};
export default LogoutButton;
